import { ICompany } from "./company.model";

export class IAddressBookSearchData {
    companyId: string;
    sortBy: string;
    sortOrder: string;
    filterString: string;
    companyName: string;
    pazesize: number;
    pageStartIndex: number;
    totalNumberOfRecords: number;
    resultSet: ICompany[];
    constructor(){
    }
}